module.exports = __webpack_public_path__ + "static/scissorlift-7628fdf9445c0c47070a4f73058c2f13.png";